<template>
  <div class="sample-detail-header">
    <div class="header-controls">
      <section class="sample-title">
        <h2>Oil Sample</h2>
        <button
          type="button"
          class="k-primary k-button k-grid-edit-command"
          @click="saveHandler(false, false)"
          tabindex="600"
          :disabled="!validSampleData"
        >
          <span class="icon">Save & New</span>
        </button>
        <button
          type="button"
          class="k-primary k-button k-grid-edit-command"
          @click="saveHandler(true, false)"
          tabindex="600"
          :disabled="!validSampleData"
        >
          <span class="icon">Save</span>
        </button>
        <button
          type="button"
          class="k-primary k-button k-grid-edit-command del-btn"
          @click="saveHandler(false, true)"
          tabindex="600"
          :disabled="!validSampleData"
        >
          <span class="icon">Delete</span>
        </button>
      </section>
      <section class="sample-options">
        <button
          type="button"
          class="nav-icon icon no-hover"
          :disabled="!sampleData.previousSampleID"
          @click="prevHandler"
          @blur="resetFocus($event, sampleData.nextSampleID)"
          tabindex="625"
        >
          <span class="icon icon-keyboard_arrow_left"></span>
        </button>
        <button type="button" class="nav-icon no-hover" @click="nextHandler" tabindex="630" @blur="resetFocus">
          <span class="icon icon-keyboard_arrow_right"></span>
        </button>
        <button type="button" class="k-primary k-button" @click="unitHistoryHandler" tabindex="605">Unit ID History</button>
        <button type="button" class="k-primary k-button" @click="viewReportHandler" tabindex="610">View Report</button>
        <button type="button" class="k-primary k-button" @click="graphDataHandler" tabindex="615">Graph Data</button>
        <button type="button" class="k-primary k-button" @click="graphHistoryHandler" tabindex="620">Graph History</button>
      </section>
    </div>
    <div class="header-information">
      <p>
        <span class="updated">
          Last Updated by
          <span class="bold">
            {{ sampleData.modifiedBy || '...' }}
          </span>
          <span v-if="sampleData.modifiedBy && sampleData.modifiedOn"> on {{ sampleData.modifiedOn }} </span>
        </span>
        <span class="created">
          Created by
          <span class="bold">
            {{ sampleData.createdBy || '...' }}
          </span>
          <span v-if="sampleData.createdBy && sampleData.createdOn"> on {{ sampleData.createdOn }} </span>
        </span>
      </p>
    </div>
  </div>
</template>

<script>
import KendoConstants from '../../../../constants/kendo.constants';
import OilSampleEndpoint from '../../../constants/api/endpoint/oil-sample.endpoint.constants';
import AddEditMixin from '../../shared/AddEditMixin';

export default {
  name: 'SampleDetailHeader',
  computed: {
    validSampleData() {
      return this.sampleData.sampleNumber && this.sampleData.unitID;
    },
    dialogs() {
      return Array.from(document.querySelectorAll('.k-widget.k-window.k-dialog'));
    }
  },
  data() {
    return {
      dialogJustClosed: false
    };
  },
  methods: {
    saveHandler(stayOnSample, isDelete) {
      if (this.validSampleData) {
        this.$emit('submit-add-edit-form', stayOnSample, isDelete);
      }
    },
    handleDialogClosed() {
      this.dialogJustClosed = true;
      setTimeout(() => {
        this.dialogJustClosed = false;
      }, 100);
    },
    prevHandler() {
      window.location = `${OilSampleEndpoint.addEditRoute}?id=${this.sampleData.previousSampleID}`;
    },
    nextHandler() {
      if (this.sampleData.nextSampleID) {
        window.location = `${OilSampleEndpoint.addEditRoute}?id=${this.sampleData.nextSampleID}`;
      } else {
        window.location = OilSampleEndpoint.addEditRoute;
      }
    },
    unitHistoryHandler() {
      window.open(
        `${OilSampleEndpoint.grid}?unitIdOperator=${KendoConstants.filter.operators.eq}&unitIdQuery=${this.sampleData.unitID}`,
        '_blank'
      );
    },
    viewReportHandler() {
      window.open(`${OilSampleEndpoint.reportRoute}?id=${this.sampleData.oilSampleID}`, '_blank');
    },
    graphDataHandler() {
      window.open(`${OilSampleEndpoint.graphRoute}?id=${this.sampleData.oilSampleID}`, '_blank');
    },
    graphHistoryHandler() {
      window.open(`${OilSampleEndpoint.graphRoute}?id=${this.sampleData.oilSampleID}&viewunit`, '_blank');
    },
    resetFocus(e, isPreviousSampleAndIsNextDisabled) {
      this.$emit('reset-focus', isPreviousSampleAndIsNextDisabled);
    }
  },
  mounted() {
    this.handleKeydown = event => {
      if (event.keyCode !== 13) return;

      const openDialog = this.dialogs.some(element => {
        const style = element.getAttribute('style');
        return !style || !style.includes('display: none');
      });

      if (!openDialog && !this.dialogJustClosed) {
        this.saveHandler(false);
      }
    };

    window.addEventListener('keydown', this.handleKeydown);

    // Listen for dialog-closed events from any dialog
    document.addEventListener('dialog-closed', this.handleDialogClosed);
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeydown);
    document.removeEventListener('dialog-closed', this.handleDialogClosed);
  },
  props: {
    sampleData: {
      type: Object,
      required: true
    }
  }
};
</script>
<style lang="scss" scoped>
.sample-detail-header {
  border-color: rgba(0, 0, 0, 0.08);
  border-style: solid;
  border-width: 0 0 1px;
  padding: 8px 8px 0 8px;

  .header-information {
    padding-bottom: 8px;

    .updated {
      padding-right: 50px;
    }
  }

  button {
    font-size: 20px;
    margin: 10px;

    &:focus {
      outline: -webkit-focus-ring-color auto 3px;
    }
  }

  .nav-icon {
    background-color: transparent;

    .icon {
      color: $accent;
      font-size: 40px;
    }
  }

  .header-controls {
    display: flex;
    justify-content: space-between;

    button,
    h1 {
      flex-grow: 1;
      padding: 3px 15px;
    }
    &:disabled .icon {
      color: $gray !important;
    }

    .del-btn {
      background-color: #f00;
    }
  }

  section {
    align-items: center;
    display: flex;
  }
}
</style>
